import { gql } from '@/__generated__/gql';

export const IMPORT_INITIAL_COMMITMENTS_MUTATION = gql(`
  mutation ImportDataImportInitialCommitments($data: AllocationsImportDto!) {
    importInitialCommitments(data: $data) {
      status
      summary {
        unchangedAllocations
        allocationsMarkedAsCommitted
        allocationsStillPending
      }
      errors {
        message
        id
      }
      allocationErrors {
        message
        importRow
        entityName
        investmentCode
        entityCode
        tradeDate
        netAmount
        investmentId
        legalEntityId
      }
      allocationComparisons {
        investmentCode
        entityCode
        investmentId
        legalEntityId
        validated
        legalEntity {
          id
          entityName
          tenant {
            name
          }
        }
        investment {
          id
          name
        }
        importAllocations {
          entityCode
          investmentCode
          netAmount
        }
        existingEntityCode
        existingInvestmentCodes
        existingAllocations {
          id
          committedCapital
          allocationStatus
          legalEntity {
            id
            entityName
          }
          investment {
            id
            name
          }
        }
        pendingAllocations {
          id
          allocationStatus
          committedCapital
          legalEntity {
            id
            entityName
          }
          investment {
            id
            name
          }
        }
        importTotal
        importCount
        committedTotal
        pendingAmount
      }
      mismatchedAllocationErrors {
        message
        allocationComparison {
          investmentCode
          entityCode
          investmentId
          legalEntityId
          legalEntity {
            id
            entityName
            tenant {
              name
            }
          }
          investment {
            id
            name
          }
          importAllocations {
            entityCode
            investmentCode
            netAmount
          }
          existingAllocations {
            id
            committedCapital
            allocationStatus
            legalEntity {
              id
              entityName
            }
            investment {
              id
              name
            }
          }
          existingEntityCode
          existingInvestmentCodes
          pendingAllocations {
            id
            allocationStatus
            committedCapital
            legalEntity {
              id
              entityName
            }
            investment {
              id
              name
            }
          }
          importTotal
          importCount
          committedTotal
          pendingAmount
        }
      }
      mismatchedAllocationwarnings {
        message
        investmentId
        legalEntityId
        committedCapital
      }
    }
  }
`);

export const IMPORT_COMMITMENTS_TRANSACTION_MUTATION = gql(`
  mutation ImportDataImportCommitmentsTransaction($data: CommitmentTransactionImportDto!) {
    importCommitmentsTransaction(data: $data) {
      status
      errors {
        message
        id
      }
      commitmentErrors {
        message
        importRow
        investmentCode
        entityCode
      }
    }
  }
`);

export const IMPORT_COMMITMENTS_DETAIL_MUTATION = gql(`
  mutation ImportDataImportCommitmentsDetail($data: CommitmentDetailsImportDto!) {
    importCommitmentsDetail(data: $data) {
      status
      errors {
        message
        id
      }
      commitmentErrors {
        message
        importRow
        investmentCode
        entityCode
      }
    }
  }
`);

export const CREATE_INVESTMENT_VEHICLE_MUTATION = gql(`
  mutation ImportDataCreateInvestmentVehicle($data: InvestmentVehicleCreateDto!) {
    createInvestmentVehicle(data: $data) {
      id
      investmentId
    }
  }
`);

export const LEGAL_ENTITIES_QUERY = gql(`
  query ImportDataLegalEntities($filter: LegalEntityFilter) {
    LegalEntities(filter: $filter) {
      id
      entityName
      advisorCRMId
      tenant {
        id
        name
      }
      family {
        id
        name
      }
    }
  }
`);

export const LIST_INVESTMENT_VEHICLES_QUERY = gql(`
  query ImportDataInvestmentVehicles($data: InvestmentVehiclesRequestDto!) {
    investmentVehicles(data: $data) {
      id
      investmentId
      investment {
        id
        name
      }
    }
  }
`);

export const INVESTMENTS_QUERY_BASIC = gql(`
  query ImportDataInvestmentsBasic($page: Int, $rowsPerPage: Int) {
    Investments(page: $page, rowsPerPage: $rowsPerPage) {
      total
      page
      perPage
      data {
        id
        name
      }
    }
  }
`);

export const LIST_ENTITIES_QUERY_BASIC = gql(`
  query ImportDataListEntitiesBasic($data: LegalEntityListInputDto!) {
    listEntities(data: $data) {
      data {
        id
        entityName
        importId
        tenant {
          name
        }
      }
    }
  }
`);

export const IMPORT_LEGAL_ENTITIES_MUTATION = gql(`
  mutation ImportDataImportLegalEntities($data: LegalEntityImportArgs!) {
    importLegalEntities(data: $data) {
      entityResponse {
        newEntitiesCount
        updatedEntitiesCount
        unchangedEntitiesCount
        entityImportComparisons {
          id
          entityCRMId
          entityName
          householdName
          fieldsModifiedCount
          status
          isNew
          entityFieldComparisons {
            fieldName
            currentValue
            newValue
            status
            tooltip
          }
        }
      }
      householdResponse {
        newHouseholdsCount
        updatedHouseholdsCount
        householdsToDeleteCount
        householdComparisons {
          householdName
          totalEntities
          entitiesAdded
          entitiesRemoved
          advisorEmail
          advisorConflict
          status
          entityAdvisors {
            entityName
            existingEmail
            importEmail
            status
          }
        }
      }
      groupResponse {
        newGroupsCount
        updateGroupsCount
        groupsToDeleteCount
        groupImportComparisons {
          groupName
          householdName
          totalGrouped
          newlyGrouped
          ungrouped
          primaryEntityName
          oldPrimaryEntityId
          status
          tooltip
          entityGroups {
            id
            entityName
            isPrimaryEntity
            status
          }
        }
      }
    }
  }
`);

export const SETTINGS_PAGE_IMPORT_DATA_UPDATE_ENTITY_MUTATION = gql(`
  mutation SettingsPageImportDataUpdateEntity($data: UpdateLegalEntityInput!) {
    updateLegalEntity(data: $data) {
      id
    }
  }
`);
